import {ApiClient} from '@hconnect/apiclient'
import {AuthProvider} from '@hconnect/login'
import {customThemeConstants} from '@hconnect/uikit/src/lib2'
import {UpmPlantsProvider} from '@hconnect/upm'
import {ToastContainer} from '@hm/fundamental'
import {CircularProgress, CssBaseline} from '@mui/material'
import {Suspense} from 'react'
import {HelmetProvider} from 'react-helmet-async'
import {useNavigate} from 'react-router'

import {App} from '../../../app/App'
import {PlannerErrorBoundary} from '../errorBoundary/PlannerErrorBoundary'
import {HCHelmet} from '../helmets/HCHelmet'
import {MaintenanceSwitch} from '../MaintenanceSwitch'

import {FullScreenProvider} from './FullscreenProvider'
import {LoginGuard} from './LoginGuard'
import {QueryProvider} from './QueryProvider'

export const Provider: React.FC = () => {
  const {palette} = customThemeConstants()
  const navigate = useNavigate()
  const refreshPage = () => navigate(0)

  return (
    <Suspense fallback={<CircularProgress />}>
      <CssBaseline />
      <PlannerErrorBoundary
        fallbackSx={{width: 'auto', maxWidth: ({spacing}) => spacing(60)}}
        fallbackWrapperSx={{
          height: '100vh',
          background: palette.backgroundGradient,
          justifyContent: 'center',
          alignItems: 'center'
        }}
        onRetry={refreshPage}
        fallbackTestId="global_planner_error_fallback"
      >
        <HelmetProvider>
          <HCHelmet />
          <MaintenanceSwitch>
            <ToastContainer closeOnClick />
            <QueryProvider>
              <FullScreenProvider>
                <AuthProvider>
                  <LoginGuard>
                    <UpmPlantsProvider api={ApiClient.axiosInstance}>
                      <App />
                    </UpmPlantsProvider>
                  </LoginGuard>
                </AuthProvider>
              </FullScreenProvider>
            </QueryProvider>
          </MaintenanceSwitch>
        </HelmetProvider>
      </PlannerErrorBoundary>
    </Suspense>
  )
}
